<template>
  <b-skeleton-wrapper :loading="loading && isFullLoading">
    <template #loading>
      <div class="alert-widget">
        <div class="__left-content">
          <b-skeleton width="60%" height="16px" class="mb-0" />
          <b-skeleton width="40%" height="24px" class="mb-0" />
        </div>
        <div class="__right-content">
          <b-skeleton type="avatar" width="10px" height="10px" class="mb-0" />
        </div>
      </div>
    </template>
    <div class="alert-widget">
      <div class="__left-content">
        <div class="__title">
          {{ title }}
        </div>
        <div class="__counter">
          <b-skeleton v-if="loading && !isFullLoading" width="40px" height="24px" class="mb-0" />
          <template v-else>
            {{ counter }}
          </template>
        </div>
      </div>
      <div class="__right-content">
        <div class="indicator" :class="indicatorColor" />
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    counter: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isFullLoading: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    indicatorColor() {
      return { [`${this.counter > 0 ? 'red' : 'green'}-indicator`]: true }
    }
  },
}
</script>

<style lang="scss" scoped>
.alert-widget {
  display: flex;
  padding: 12px;
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $teal-100;
  width: 164px;
  gap: 8px;

  user-select: none;

  .__left-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 8px;

    .__title {
      font-size: 11px;
      line-height: 16px;
      color: $mep-color-text-300;
    }

    .__counter {
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      color: $mep-color-text-400;
    }
  }

  .__right-content {
    flex-grow: 0;
  }
}

.indicator {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 28.8px;
  z-index: 1;
  margin: 3px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    background-color: inherit;

    // animate opacity & scale
    filter: blur(3px);
    animation: pulse-glow 2s ease-in-out infinite;
    
    opacity: 0;
    transform: scale(0);
    z-index: -1;
  }
}

.green-indicator {
  background-color: $green;
}

.red-indicator {
  background-color: $red-600;
}

@keyframes pulse-glow {
  0%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}
</style>